export function getDataTaxQueries(parent) {
    if (parent.dataset.ctTaxQuery) {
        const taxQuery = JSON.parse(parent.dataset.ctTaxQuery);
        if (taxQuery) {
            return new URLSearchParams(taxQuery).toString();
        }

        return false;
    }
}
